var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-icon",class:_vm.icon.color},[(_vm.icon)?_c('img',{attrs:{"src":require(`@/assets/device-icons/${_vm.icon.id === 'weather-station-xsense' ? 'weather-station' : _vm.icon.id}.svg`)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }